/* import __COLOCATED_TEMPLATE__ from './signup.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();